import { CollabItem } from 'components/CollabItem'
import { List } from 'components/CollabItem/List/List'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import { computed } from 'mobx'
import { Thread } from '../CommentV2/Thread/Thread'
import { CommentItem } from './CommentItem'
import { Comment as CommentType } from 'types'
import { ReplyItem } from './ReplyItem'

interface Props {
  items: CommentType[]
}

const Comment = observer(({ items }: Props) => {
  const rootStore = useRootStore()
  const comment = items[0]
  const isActive = computed(() => rootStore.comments.selected?.id === comment.id).get()
  const isHighlighted = computed(() => rootStore.comments.highlighted?.id === comment.id).get()
  const ref = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    if (isActive) {
      return
    }
    rootStore.comments.select(comment.id)
  }

  const handleMouseOver = () => {
    if (isActive || isHighlighted) {
      return
    }
    rootStore.comments.highlight(comment.id)
  }

  const handleMouseLeave = () => {
    rootStore.comments.highlight(undefined)
  }

  const handleClickOutside = () => {
    if (isActive) {
      rootStore.comments.select(undefined)
    }
  }

  return (
    <CollabItem.Root
      isActive={isActive}
      isHighlighted={isHighlighted}
      onClick={handleClick}
      onClickOutside={handleClickOutside}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      ref={ref}
    >
      <Thread items={items}>
        <List collapsed={false} onToggle={handleClickOutside} itemId={comment.id}>
          <CommentItem comment={comment} />
          {items.slice(1).map((item) => (
            <ReplyItem key={item.id} comment={item} />
          ))}
        </List>
      </Thread>
    </CollabItem.Root>
  )
})

export { Comment }
